import React, { useState, useEffect } from 'react';
import { Box, Typography, List, ListItem, ListItemText, IconButton } from '@mui/material';
import { Link } from 'react-router-dom';
import axios from 'axios';
import DeleteIcon from '@mui/icons-material/Delete';

const Favourites = (props) => {
    const [favorites, setFavorites] = useState([]);
    const [loading, setLoading] = useState(true);
    const [query, setQuery] = useState('');
    const { visible, setVisible } = props;

    const favouritesUrl = process.env.REACT_APP_SERVER
        ? 'https://salonserver-k8m8.onrender.com/favourites'
        : 'http://localhost:3001/favourites';
    const addFavouritesUrl = process.env.REACT_APP_SERVER
        ? 'https://salonserver-k8m8.onrender.com/favourites'
        : 'http://localhost:3001/favourites';
    const delFavouritesUrl = process.env.REACT_APP_SERVER
        ? 'https://salonserver-k8m8.onrender.com/favourites'
        : 'http://localhost:3001/favourites';

    useEffect(() => {
        setVisible(false);
        const fetchFavorites = async () => {
            try {
                const response = await axios.get(favouritesUrl, {
                    headers: {
                        "Content-Type": "application/json",
                        "Accept": "application/json",
                        "Authorization": ` ${localStorage.getItem("token")}  `,
                    },
                });
                console.log('Fetched favorites:', response.data);
                setFavorites(response.data);
            } catch (error) {
                console.error('Error fetching favorites:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchFavorites();
    }, []);

    const removeFavorite = async (salon_id) => {

        try {
            await axios.delete(delFavouritesUrl, {
                headers: { Authorization: ` ${localStorage.getItem('token')}` },
                params: { salon_id: salon_id },
            });
            setFavorites(favorites.filter(fav => fav.id !== salon_id));
        } catch (error) {
            console.error('Error removing favorite:', error);
        }
    };
    // const handleSelect = (salon) => {
    //     setQuery(salon.name);
    //     setResults([]);
    //     if (onSelectSalon) onSelectSalon(salon);
    //     setQuery('');
    // };

    if (loading) return <Typography>Loading favorites...</Typography>;
    if (favorites.length === 0) return <Typography variant="h4" style={{ minHeight: '65vh' }}>No favorites yet.</Typography>;

    return (
        <Box sx={{ p: 2 }} style={{ minHeight: '65vh' }}>
            <Typography variant="h4">Favorites</Typography>
            <List>

                {favorites.map((salon) => (
                    <Link
                        to={`/salon/${salon.id}`} // Navigate to salon page
                        key={salon.id}
                        style={{ textDecoration: 'none', color: 'inherit' }} // Remove default link styling
                    // onClick={() => handleSelect(salon)}
                    >
                        <img
                            src={salon.get_image_url || '/placeholder-image.jpg'} // Fallback image if URL is missing
                            alt={salon.name}
                            // style={{ width: 250, height: 150, objectFit: 'cover', borderRadius: 4, marginRight: 10 }}
                            style={{
                                width: '100%',          // Full width of parent container
                                maxWidth: 250,          // Prevents it from stretching too much on large screens
                                height: 'auto',         // Keeps correct aspect ratio
                                aspectRatio: '5 / 3',   // Optional: consistent shape on all devices
                                objectFit: 'cover',
                                borderRadius: 8,
                                marginRight: 10,
                            }}
                        />
                        <ListItem
                            key={salon.id}
                            secondaryAction={
                                <IconButton edge="end" aria-label="delete" onClick={() => removeFavorite(salon.id)}>
                                    <DeleteIcon />
                                </IconButton>
                            }
                        >
                            <ListItemText
                                primary={salon.name}
                                secondary={`Pincode: ${salon.pincode || 'N/A'}, `}
                            />
                        </ListItem>
                    </Link>
                ))}
            </List>
        </Box>
    );
};

export default Favourites;